export const API_USAGE_FOR_VEHICLE_REPORT_INCREMENT = "V3_API_USAGE_FOR_VEHICLE_REPORT_INCREMENT";